app.tabs = {
    settings: {
        parent: null,
        tabSelector: '[data-tab]'
    },

    init: function(){
        if( app.tabs.settings.tabSelector.length > 0 ) {
            app.settings.$document.on('click', app.tabs.settings.tabSelector, function(event) {
                event.preventDefault();

                if( ! $(this).hasClass('tab--active') ) {
                    app.tabs.select( this );
                }
            });
        }
    },

    select: function(tab) {
        var $tab = $(tab);
        var id = $tab.data('tab');

        app.tabs.deselect();
        $('[data-tab="' + id + '"]').addClass('tab--active');
        app.tabs.dropdown(id);
    },

    deselect: function() {
        $(app.tabs.settings.tabSelector).removeClass('tab--active');
    },

    dropdown: function(id) {
        $('.tab__content').hide();
        $('#' + id).fadeIn('fast');
    }
};